export const quotesMenuMixin = {
    beforeCreate: function (){
        this.actualUrl = window.location.href;
    },
    methods: {
        isTreeNameActive: function (name) {
            return this.actualUrl.indexOf(name) !=  -1;
        }
    }
};
